"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2732],{

/***/ 2732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ TextStyles; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53918);
/**
 * @deprecated
 */

const TextStyles = {
  headingMontserratH1WhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:28px;line-height:1.29;letter-spacing:0.86px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref => {
    let {
      theme
    } = _ref;
    return theme.palette.baseWhite;
  }),
  headingMontserratH1WhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:28px;line-height:1.29;text-align:right;letter-spacing:0.52px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref2 => {
    let {
      theme
    } = _ref2;
    return theme.palette.baseWhite;
  }),
  headingMontserratH1WhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:28px;line-height:1.29;text-align:center;letter-spacing:0.86px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref3 => {
    let {
      theme
    } = _ref3;
    return theme.palette.baseWhite;
  }),
  headingMontserratH1G900SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:28px;line-height:1.29;text-align:inherit;letter-spacing:0.86px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref4 => {
    let {
      theme
    } = _ref4;
    return theme.palette.primaryGreen900;
  }),
  headingMontserratH1DarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1.75rem;line-height:1.3;text-align:inherit;letter-spacing:0.86px;color:", ";font-family:Montserrat-SemiBold,sans-serif;"], _ref5 => {
    let {
      theme
    } = _ref5;
    return theme.palette.baseDark;
  }),
  headingMontserratH1DarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:28px;line-height:1.3;text-align:right;letter-spacing:0.86px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref6 => {
    let {
      theme
    } = _ref6;
    return theme.palette.baseDark;
  }),
  headingMontserratH1DarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1.75rem;line-height:36.4px;text-align:center;letter-spacing:0.86px;color:", ";font-family:Montserrat-SemiBold,sans-serif;"], _ref7 => {
    let {
      theme
    } = _ref7;
    return theme.palette.baseDark;
  }),
  headingMontserratH2WhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1.5rem;line-height:31px;text-align:inherit;letter-spacing:0.68px;color:", ";font-family:Montserrat-SemiBold,sans-serif;font-weight:600;"], _ref8 => {
    let {
      theme
    } = _ref8;
    return theme.palette.baseWhite;
  }),
  headingMontserratH2WhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:24px;line-height:1.29;text-align:right;letter-spacing:0.68px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref9 => {
    let {
      theme
    } = _ref9;
    return theme.palette.baseWhite;
  }),
  headingMontserratH2WhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:24px;line-height:1.29;text-align:center;letter-spacing:0.68px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref10 => {
    let {
      theme
    } = _ref10;
    return theme.palette.baseWhite;
  }),
  headingMontserratH2DarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:24px;line-height:1.3;text-align:inherit;letter-spacing:0.68px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref11 => {
    let {
      theme
    } = _ref11;
    return theme.palette.baseDark;
  }),
  headingMontserratH2DarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:24px;line-height:1.3;text-align:right;letter-spacing:0.68px;color:", ";font-family:Montserrat,sans-serif;"], _ref12 => {
    let {
      theme
    } = _ref12;
    return theme.palette.baseDark;
  }),
  headingMontserratH2DarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:24px;line-height:1.3;text-align:center;letter-spacing:0.68px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref13 => {
    let {
      theme
    } = _ref13;
    return theme.palette.baseDark;
  }),
  headingMontserratH3WhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:22px;line-height:1.27;text-align:inherit;letter-spacing:0.6px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref14 => {
    let {
      theme
    } = _ref14;
    return theme.palette.baseWhite;
  }),
  headingMontserratH3WhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:22px;line-height:1.27;text-align:right;letter-spacing:0.6px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref15 => {
    let {
      theme
    } = _ref15;
    return theme.palette.baseWhite;
  }),
  headingMontserratH3WhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:22px;line-height:1.27;text-align:center;letter-spacing:0.6px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref16 => {
    let {
      theme
    } = _ref16;
    return theme.palette.baseWhite;
  }),
  headingMontserratH3DarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1.375rem;line-height:28.6px;text-align:inherit;letter-spacing:0.6px;color:", ";font-family:Montserrat-SemiBold,sans-serif;"], _ref17 => {
    let {
      theme
    } = _ref17;
    return theme.palette.baseDark;
  }),
  headingMontserratH3DarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:22px;line-height:1.3;text-align:right;letter-spacing:0.6px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref18 => {
    let {
      theme
    } = _ref18;
    return theme.palette.baseDark;
  }),
  headingMontserratH3DarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1.375rem;line-height:28.6px;text-align:center;letter-spacing:0.6px;color:", ";font-family:Montserrat-SemiBold,sans-serif;font-weight:400;"], _ref19 => {
    let {
      theme
    } = _ref19;
    return theme.palette.baseDark;
  }),
  headingMontserratH4WhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:inherit;letter-spacing:0.58px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref20 => {
    let {
      theme
    } = _ref20;
    return theme.palette.baseWhite;
  }),
  headingMontserratH4WhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:right;letter-spacing:0.58px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref21 => {
    let {
      theme
    } = _ref21;
    return theme.palette.baseWhite;
  }),
  headingMontserratH4WhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:center;letter-spacing:0.58px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref22 => {
    let {
      theme
    } = _ref22;
    return theme.palette.baseWhite;
  }),
  headingMontserratH4DarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:inherit;letter-spacing:0.58px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref23 => {
    let {
      theme
    } = _ref23;
    return theme.palette.baseDark;
  }),
  headingMontserratH4DarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:right;letter-spacing:0.58px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref24 => {
    let {
      theme
    } = _ref24;
    return theme.palette.baseDark;
  }),
  headingMontserratH4DarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:center;letter-spacing:0.58px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref25 => {
    let {
      theme
    } = _ref25;
    return theme.palette.baseDark;
  }),
  bodyLWhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:inherit;letter-spacing:0.57px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref26 => {
    let {
      theme
    } = _ref26;
    return theme.palette.baseWhite;
  }),
  bodyLWhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:right;letter-spacing:0.57px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref27 => {
    let {
      theme
    } = _ref27;
    return theme.palette.baseWhite;
  }),
  bodyLWhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:center;letter-spacing:0.57px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref28 => {
    let {
      theme
    } = _ref28;
    return theme.palette.baseWhite;
  }),
  bodyLN700SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.2;text-align:inherit;letter-spacing:0.57px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref29 => {
    let {
      theme
    } = _ref29;
    return theme.palette.baseNeutral700;
  }),
  bodyLN700SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.2;text-align:right;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref30 => {
    let {
      theme
    } = _ref30;
    return theme.palette.baseNeutral700;
  }),
  bodyLN700SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.2;text-align:center;letter-spacing:0.57px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref31 => {
    let {
      theme
    } = _ref31;
    return theme.palette.baseNeutral700;
  }),
  bodyLDarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1.25rem;line-height:26px;text-align:inherit;letter-spacing:0.57px;color:", ";font-family:Montserrat-SemiBold,sans-serif;"], _ref32 => {
    let {
      theme
    } = _ref32;
    return theme.palette.baseDark;
  }),
  bodyLDarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:right;letter-spacing:0.57px;color:", ";font-family:Montserrat,sans-serif;"], _ref33 => {
    let {
      theme
    } = _ref33;
    return theme.palette.baseDark;
  }),
  bodyLDarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:20px;line-height:1.3;text-align:center;letter-spacing:0.57px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref34 => {
    let {
      theme
    } = _ref34;
    return theme.palette.baseDark;
  }),
  headingMontserratH5WhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:inherit;letter-spacing:0.5px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref35 => {
    let {
      theme
    } = _ref35;
    return theme.palette.baseWhite;
  }),
  headingMontserratH5WhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:right;letter-spacing:0.5px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref36 => {
    let {
      theme
    } = _ref36;
    return theme.palette.baseWhite;
  }),
  headingMontserratH5WhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:center;letter-spacing:0.5px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref37 => {
    let {
      theme
    } = _ref37;
    return theme.palette.baseWhite;
  }),
  headingMontserratH5G900SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:inherit;letter-spacing:0.5px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref38 => {
    let {
      theme
    } = _ref38;
    return theme.palette.primaryGreen900;
  }),
  headingMontserratH5DarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.3;text-align:inherit;letter-spacing:0.5px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref39 => {
    let {
      theme
    } = _ref39;
    return theme.palette.baseDark;
  }),
  headingMontserratH5DarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.3;text-align:right;letter-spacing:0.5px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref40 => {
    let {
      theme
    } = _ref40;
    return theme.palette.baseDark;
  }),
  headingMontserratH5DarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.3;text-align:center;letter-spacing:0.5px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref41 => {
    let {
      theme
    } = _ref41;
    return theme.palette.baseDark;
  }),
  bodyMDarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref42 => {
    let {
      theme
    } = _ref42;
    return theme.palette.baseDark;
  }),
  bodyMDarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref43 => {
    let {
      theme
    } = _ref43;
    return theme.palette.baseDark;
  }),
  bodyMDarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref44 => {
    let {
      theme
    } = _ref44;
    return theme.palette.baseDark;
  }),
  bodyMN700500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.3;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref45 => {
    let {
      theme
    } = _ref45;
    return theme.palette.baseNeutral700;
  }),
  bodyMN700500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.3;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref46 => {
    let {
      theme
    } = _ref46;
    return theme.palette.baseNeutral700;
  }),
  bodyMN700500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.3;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref47 => {
    let {
      theme
    } = _ref47;
    return theme.palette.baseNeutral700;
  }),
  bodyMN700RegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:400;"], _ref48 => {
    let {
      theme
    } = _ref48;
    return theme.palette.baseNeutral700;
  }),
  bodyMN700RegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:400;"], _ref49 => {
    let {
      theme
    } = _ref49;
    return theme.palette.baseNeutral700;
  }),
  bodyMN700RegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:18px;line-height:1.28;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:400;"], _ref50 => {
    let {
      theme
    } = _ref50;
    return theme.palette.baseNeutral700;
  }),
  interactiveButtonsSWhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref51 => {
    let {
      theme
    } = _ref51;
    return theme.palette.baseWhite;
  }),
  interactiveButtonsSWhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref52 => {
    let {
      theme
    } = _ref52;
    return theme.palette.baseWhite;
  }),
  interactiveButtonsSWhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1rem;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref53 => {
    let {
      theme
    } = _ref53;
    return theme.palette.baseWhite;
  }),
  interactiveButtonsSN700SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref54 => {
    let {
      theme
    } = _ref54;
    return theme.palette.baseNeutral700;
  }),
  interactiveButtonsSN700SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref55 => {
    let {
      theme
    } = _ref55;
    return theme.palette.baseNeutral700;
  }),
  interactiveButtonsSN700SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref56 => {
    let {
      theme
    } = _ref56;
    return theme.palette.baseNeutral700;
  }),
  interactiveButtonsSN500SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref57 => {
    let {
      theme
    } = _ref57;
    return theme.palette.baseNeutral500;
  }),
  interactiveButtonsSN500SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref58 => {
    let {
      theme
    } = _ref58;
    return theme.palette.baseNeutral500;
  }),
  interactiveButtonsSN500SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref59 => {
    let {
      theme
    } = _ref59;
    return theme.palette.baseNeutral500;
  }),
  interactiveButtonsSN400SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref60 => {
    let {
      theme
    } = _ref60;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsSN400SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref61 => {
    let {
      theme
    } = _ref61;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsSN400SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref62 => {
    let {
      theme
    } = _ref62;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsSG900SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref63 => {
    let {
      theme
    } = _ref63;
    return theme.palette.primaryGreen900;
  }),
  interactiveButtonsSG900SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref64 => {
    let {
      theme
    } = _ref64;
    return theme.palette.primaryGreen900;
  }),
  interactiveButtonsSG900SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref65 => {
    let {
      theme
    } = _ref65;
    return theme.palette.primaryGreen900;
  }),
  interactiveButtonsSG800SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref66 => {
    let {
      theme
    } = _ref66;
    return theme.palette.primaryGreen800;
  }),
  interactiveButtonsSG800SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref67 => {
    let {
      theme
    } = _ref67;
    return theme.palette.primaryGreen800;
  }),
  interactiveButtonsSG800SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref68 => {
    let {
      theme
    } = _ref68;
    return theme.palette.primaryGreen800;
  }),
  interactiveButtonsSG600SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref69 => {
    let {
      theme
    } = _ref69;
    return theme.palette.primaryGreen600;
  }),
  interactiveButtonsSG600SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref70 => {
    let {
      theme
    } = _ref70;
    return theme.palette.primaryGreen600;
  }),
  interactiveButtonsSG600SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref71 => {
    let {
      theme
    } = _ref71;
    return theme.palette.primaryGreen600;
  }),
  interactiveButtonsSBlackSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref72 => {
    let {
      theme
    } = _ref72;
    return theme.palette.baseDark;
  }),
  interactiveButtonsSBlackSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref73 => {
    let {
      theme
    } = _ref73;
    return theme.palette.baseDark;
  }),
  interactiveButtonsSBlackSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref74 => {
    let {
      theme
    } = _ref74;
    return theme.palette.baseDark;
  }),
  bodySWhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref75 => {
    let {
      theme
    } = _ref75;
    return theme.palette.baseWhite;
  }),
  bodySWhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref76 => {
    let {
      theme
    } = _ref76;
    return theme.palette.baseWhite;
  }),
  bodySWhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref77 => {
    let {
      theme
    } = _ref77;
    return theme.palette.baseWhite;
  }),
  bodySN700SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref78 => {
    let {
      theme
    } = _ref78;
    return theme.palette.baseNeutral700;
  }),
  bodySN700SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref79 => {
    let {
      theme
    } = _ref79;
    return theme.palette.baseNeutral700;
  }),
  bodySN700SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref80 => {
    let {
      theme
    } = _ref80;
    return theme.palette.baseNeutral700;
  }),
  bodySN500SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref81 => {
    let {
      theme
    } = _ref81;
    return theme.palette.baseNeutral500;
  }),
  bodySN500SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref82 => {
    let {
      theme
    } = _ref82;
    return theme.palette.baseNeutral500;
  }),
  bodySN500SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref83 => {
    let {
      theme
    } = _ref83;
    return theme.palette.baseNeutral500;
  }),
  bodySG700SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref84 => {
    let {
      theme
    } = _ref84;
    return theme.palette.baseNeutral700;
  }),
  bodySG700SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref85 => {
    let {
      theme
    } = _ref85;
    return theme.palette.baseNeutral700;
  }),
  bodySG700SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref86 => {
    let {
      theme
    } = _ref86;
    return theme.palette.baseNeutral700;
  }),
  bodySG600SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref87 => {
    let {
      theme
    } = _ref87;
    return theme.palette.primaryGreen600;
  }),
  bodySG600SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref88 => {
    let {
      theme
    } = _ref88;
    return theme.palette.primaryGreen600;
  }),
  bodySG600SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref89 => {
    let {
      theme
    } = _ref89;
    return theme.palette.primaryGreen600;
  }),
  bodySDarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref90 => {
    let {
      theme
    } = _ref90;
    return theme.palette.baseDark;
  }),
  bodySDarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref91 => {
    let {
      theme
    } = _ref91;
    return theme.palette.baseDark;
  }),
  bodySDarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;font-weight:600;"], _ref92 => {
    let {
      theme
    } = _ref92;
    return theme.palette.baseDark;
  }),
  interactiveLinksSDark500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat-Medium,sans-serif;font-weight:500;"], _ref93 => {
    let {
      theme
    } = _ref93;
    return theme.palette.baseDark;
  }),
  interactiveLinksSDark500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref94 => {
    let {
      theme
    } = _ref94;
    return theme.palette.baseDark;
  }),
  interactiveLinksSDark500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref95 => {
    let {
      theme
    } = _ref95;
    return theme.palette.baseDark;
  }),
  interactiveButtonsSWhite500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref96 => {
    let {
      theme
    } = _ref96;
    return theme.palette.baseWhite;
  }),
  interactiveButtonsSWhite500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref97 => {
    let {
      theme
    } = _ref97;
    return theme.palette.baseWhite;
  }),
  interactiveButtonsSWhite500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref98 => {
    let {
      theme
    } = _ref98;
    return theme.palette.baseWhite;
  }),
  interactiveButtonsSN400500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref99 => {
    let {
      theme
    } = _ref99;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsSN400500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref100 => {
    let {
      theme
    } = _ref100;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsSN400500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;font-weight:500;"], _ref101 => {
    let {
      theme
    } = _ref101;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsSG800500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref102 => {
    let {
      theme
    } = _ref102;
    return theme.palette.primaryGreen800;
  }),
  interactiveButtonsSG800500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref103 => {
    let {
      theme
    } = _ref103;
    return theme.palette.primaryGreen800;
  }),
  interactiveButtonsSG800500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref104 => {
    let {
      theme
    } = _ref104;
    return theme.palette.primaryGreen800;
  }),
  interactiveButtonsSG600500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref105 => {
    let {
      theme
    } = _ref105;
    return theme.palette.primaryGreen600;
  }),
  interactiveButtonsSG600500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref106 => {
    let {
      theme
    } = _ref106;
    return theme.palette.primaryGreen600;
  }),
  interactiveButtonsSG600500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:normal;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref107 => {
    let {
      theme
    } = _ref107;
    return theme.palette.primaryGreen600;
  }),
  bodySWhite500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref108 => {
    let {
      theme
    } = _ref108;
    return theme.palette.baseWhite;
  }),
  bodySWhite500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref109 => {
    let {
      theme
    } = _ref109;
    return theme.palette.baseWhite;
  }),
  bodySWhite500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref110 => {
    let {
      theme
    } = _ref110;
    return theme.palette.baseWhite;
  }),
  bodySN700500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref111 => {
    let {
      theme
    } = _ref111;
    return theme.palette.baseNeutral700;
  }),
  bodySN700500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref112 => {
    let {
      theme
    } = _ref112;
    return theme.palette.baseNeutral700;
  }),
  bodySN700500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref113 => {
    let {
      theme
    } = _ref113;
    return theme.palette.baseNeutral700;
  }),
  bodySG900500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref114 => {
    let {
      theme
    } = _ref114;
    return theme.palette.primaryGreen900;
  }),
  bodySG900500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:right;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref115 => {
    let {
      theme
    } = _ref115;
    return theme.palette.primaryGreen900;
  }),
  bodySG900500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.43;text-align:center;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref116 => {
    let {
      theme
    } = _ref116;
    return theme.palette.primaryGreen900;
  }),
  bodySG700500StrikeSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:#646b73;font-family:Montserrat,sans-serif;"]),
  bodySG700500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref117 => {
    let {
      theme
    } = _ref117;
    return theme.palette.baseNeutral700;
  }),
  bodySG700500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref118 => {
    let {
      theme
    } = _ref118;
    return theme.palette.baseNeutral700;
  }),
  bodySG700500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref119 => {
    let {
      theme
    } = _ref119;
    return theme.palette.baseNeutral700;
  }),
  bodySDark500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.3px;color:", ";font-family:Montserrat,sans-serif;"], _ref120 => {
    let {
      theme
    } = _ref120;
    return theme.palette.baseDark;
  }),
  bodySDark500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.3px;color:#373737;font-family:Montserrat,sans-serif;"]),
  bodySDark500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.3px;color:#303131;font-family:Montserrat,sans-serif;"]),
  bodySN700RegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref121 => {
    let {
      theme
    } = _ref121;
    return theme.palette.baseNeutral700;
  }),
  bodySN700RegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref122 => {
    let {
      theme
    } = _ref122;
    return theme.palette.baseNeutral700;
  }),
  bodySN700RegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref123 => {
    let {
      theme
    } = _ref123;
    return theme.palette.baseNeutral700;
  }),
  bodySN500RegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref124 => {
    let {
      theme
    } = _ref124;
    return theme.palette.baseNeutral500;
  }),
  bodySN500RegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref125 => {
    let {
      theme
    } = _ref125;
    return theme.palette.baseNeutral500;
  }),
  bodySN500RegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref126 => {
    let {
      theme
    } = _ref126;
    return theme.palette.baseNeutral500;
  }),
  bodySG600RegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref127 => {
    let {
      theme
    } = _ref127;
    return theme.palette.primaryGreen600;
  }),
  bodySG600RegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref128 => {
    let {
      theme
    } = _ref128;
    return theme.palette.primaryGreen600;
  }),
  bodySG600RegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref129 => {
    let {
      theme
    } = _ref129;
    return theme.palette.primaryGreen600;
  }),
  bodySDarkRegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1rem;line-height:20.8px;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat-Regular,sans-serif;"], _ref130 => {
    let {
      theme
    } = _ref130;
    return theme.palette.baseDark;
  }),
  bodySDarkRegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:16px;line-height:1.3;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref131 => {
    let {
      theme
    } = _ref131;
    return theme.palette.baseDark;
  }),
  bodySDarkRegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1rem;line-height:20.8px;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat-Regular,sans-serif;"], _ref132 => {
    let {
      theme
    } = _ref132;
    return theme.palette.baseDark;
  }),
  interactiveMenuDarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:normal;text-align:inherit;letter-spacing:0.25px;color:", ";font-family:Montserrat-SemiBold,sans-serif;"], _ref133 => {
    let {
      theme
    } = _ref133;
    return theme.palette.baseNeutral700;
  }),
  interactiveLinksXsWhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:inherit;letter-spacing:0.1px;color:", ";font-family:Montserrat,sans-serif;"], _ref134 => {
    let {
      theme
    } = _ref134;
    return theme.palette.baseWhite;
  }),
  interactiveLinksXsWhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:right;letter-spacing:0.1px;color:", ";font-family:Montserrat,sans-serif;"], _ref135 => {
    let {
      theme
    } = _ref135;
    return theme.palette.baseWhite;
  }),
  interactiveLinksXsWhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:center;letter-spacing:0.1px;color:", ";font-family:Montserrat,sans-serif;"], _ref136 => {
    let {
      theme
    } = _ref136;
    return theme.palette.baseWhite;
  }),
  interactiveLinksXsG600SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:inherit;letter-spacing:0.1px;color:", ";font-family:Montserrat,sans-serif;"], _ref137 => {
    let {
      theme
    } = _ref137;
    return theme.palette.primaryGreen600;
  }),
  interactiveLinksXsG600SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:right;letter-spacing:0.1px;color:", ";font-family:Montserrat,sans-serif;"], _ref138 => {
    let {
      theme
    } = _ref138;
    return theme.palette.primaryGreen600;
  }),
  interactiveLinksXsG600SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:center;letter-spacing:0.1px;color:", ";font-family:Montserrat,sans-serif;"], _ref139 => {
    let {
      theme
    } = _ref139;
    return theme.palette.primaryGreen600;
  }),
  interactiveButtonsXsG900SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:normal;text-align:inherit;letter-spacing:0.26px;color:", ";font-family:Montserrat,sans-serif;"], _ref140 => {
    let {
      theme
    } = _ref140;
    return theme.palette.primaryGreen900;
  }),
  interactiveButtonsXsG900SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:normal;text-align:right;letter-spacing:0.26px;color:", ";font-family:Montserrat,sans-serif;"], _ref141 => {
    let {
      theme
    } = _ref141;
    return theme.palette.primaryGreen900;
  }),
  interactiveButtonsXsG900SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:normal;text-align:center;letter-spacing:0.26px;color:", ";font-family:Montserrat,sans-serif;"], _ref142 => {
    let {
      theme
    } = _ref142;
    return theme.palette.primaryGreen900;
  }),
  infoStrikeN700SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref143 => {
    let {
      theme
    } = _ref143;
    return theme.palette.baseNeutral700;
  }),
  infoStrikeN700SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref144 => {
    let {
      theme
    } = _ref144;
    return theme.palette.baseNeutral700;
  }),
  infoStrikeN700SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref145 => {
    let {
      theme
    } = _ref145;
    return theme.palette.baseNeutral700;
  }),
  bodyXsWhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref146 => {
    let {
      theme
    } = _ref146;
    return theme.palette.baseWhite;
  }),
  bodyXsWhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref147 => {
    let {
      theme
    } = _ref147;
    return theme.palette.baseWhite;
  }),
  bodyXsWhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref148 => {
    let {
      theme
    } = _ref148;
    return theme.palette.baseWhite;
  }),
  bodyXsN700SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.57;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref149 => {
    let {
      theme
    } = _ref149;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN700SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.57;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref150 => {
    let {
      theme
    } = _ref150;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN700SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.57;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref151 => {
    let {
      theme
    } = _ref151;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN500SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref152 => {
    let {
      theme
    } = _ref152;
    return theme.palette.baseNeutral500;
  }),
  bodyXsN500SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref153 => {
    let {
      theme
    } = _ref153;
    return theme.palette.baseNeutral500;
  }),
  bodyXsN500SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref154 => {
    let {
      theme
    } = _ref154;
    return theme.palette.baseNeutral500;
  }),
  bodyXsG600SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.57;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref155 => {
    let {
      theme
    } = _ref155;
    return theme.palette.primaryGreen600;
  }),
  bodyXsG600SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.57;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref156 => {
    let {
      theme
    } = _ref156;
    return theme.palette.primaryGreen600;
  }),
  bodyXsG600SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.57;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref157 => {
    let {
      theme
    } = _ref157;
    return theme.palette.primaryGreen600;
  }),
  bodyXsDarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref158 => {
    let {
      theme
    } = _ref158;
    return theme.palette.baseDark;
  }),
  bodyXsDarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref159 => {
    let {
      theme
    } = _ref159;
    return theme.palette.baseDark;
  }),
  bodyXsDarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref160 => {
    let {
      theme
    } = _ref160;
    return theme.palette.baseDark;
  }),
  interactiveButtonsXsDark500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:normal;text-align:inherit;letter-spacing:0.26px;color:#303131;font-family:Montserrat,sans-serif;"]),
  interactiveButtonsXsDark500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:normal;text-align:right;letter-spacing:0.26px;color:#303131;font-family:Montserrat,sans-serif;"]),
  interactiveButtonsXsDark500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:normal;text-align:center;letter-spacing:0.26px;color:#303131;font-family:Montserrat,sans-serif;"]),
  infoSN700500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref161 => {
    let {
      theme
    } = _ref161;
    return theme.palette.baseNeutral700;
  }),
  infoSN700500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref162 => {
    let {
      theme
    } = _ref162;
    return theme.palette.baseNeutral700;
  }),
  infoSN700500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref163 => {
    let {
      theme
    } = _ref163;
    return theme.palette.baseNeutral700;
  }),
  infoSDark500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref164 => {
    let {
      theme
    } = _ref164;
    return theme.palette.baseDark;
  }),
  infoSDark500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref165 => {
    let {
      theme
    } = _ref165;
    return theme.palette.baseDark;
  }),
  infoSDark500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.3;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref166 => {
    let {
      theme
    } = _ref166;
    return theme.palette.baseDark;
  }),
  bodyXsN700500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref167 => {
    let {
      theme
    } = _ref167;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN700500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref168 => {
    let {
      theme
    } = _ref168;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN700500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref169 => {
    let {
      theme
    } = _ref169;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN500500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref170 => {
    let {
      theme
    } = _ref170;
    return theme.palette.baseNeutral500;
  }),
  bodyXsN500500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref171 => {
    let {
      theme
    } = _ref171;
    return theme.palette.baseNeutral500;
  }),
  bodyXsN500500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref172 => {
    let {
      theme
    } = _ref172;
    return theme.palette.baseNeutral500;
  }),
  bodyXsG900500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref173 => {
    let {
      theme
    } = _ref173;
    return theme.palette.primaryGreen900;
  }),
  bodyXsG900500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref174 => {
    let {
      theme
    } = _ref174;
    return theme.palette.primaryGreen900;
  }),
  bodyXsG900500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref175 => {
    let {
      theme
    } = _ref175;
    return theme.palette.primaryGreen900;
  }),
  bodyXsG700500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref176 => {
    let {
      theme
    } = _ref176;
    return theme.palette.baseNeutral700;
  }),
  bodyXsG700500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref177 => {
    let {
      theme
    } = _ref177;
    return theme.palette.baseNeutral700;
  }),
  bodyXsG700500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref178 => {
    let {
      theme
    } = _ref178;
    return theme.palette.baseNeutral700;
  }),
  bodyXsG600500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref179 => {
    let {
      theme
    } = _ref179;
    return theme.palette.primaryGreen600;
  }),
  bodyXsG600500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref180 => {
    let {
      theme
    } = _ref180;
    return theme.palette.primaryGreen600;
  }),
  bodyXsG600500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref181 => {
    let {
      theme
    } = _ref181;
    return theme.palette.primaryGreen600;
  }),
  bodyXsDark500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref182 => {
    let {
      theme
    } = _ref182;
    return theme.palette.baseDark;
  }),
  bodyXsDark500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref183 => {
    let {
      theme
    } = _ref183;
    return theme.palette.baseDark;
  }),
  bodyXsDark500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref184 => {
    let {
      theme
    } = _ref184;
    return theme.palette.baseDark;
  }),
  feedbackWarningRegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref185 => {
    let {
      theme
    } = _ref185;
    return theme.palette.feedbackWarning;
  }),
  feedbackWarningRegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref186 => {
    let {
      theme
    } = _ref186;
    return theme.palette.feedbackWarning;
  }),
  feedbackWarningRegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref187 => {
    let {
      theme
    } = _ref187;
    return theme.palette.feedbackWarning;
  }),
  feedbackSuccessRegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref188 => {
    let {
      theme
    } = _ref188;
    return theme.palette.feedbackSuccess;
  }),
  feedbackSuccessRegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref189 => {
    let {
      theme
    } = _ref189;
    return theme.palette.feedbackSuccess;
  }),
  feedbackSuccessRegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref190 => {
    let {
      theme
    } = _ref190;
    return theme.palette.feedbackSuccess;
  }),
  feedbackErrorRegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref191 => {
    let {
      theme
    } = _ref191;
    return theme.palette.feedbackError;
  }),
  feedbackErrorRegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref192 => {
    let {
      theme
    } = _ref192;
    return theme.palette.feedbackError;
  }),
  feedbackErrorRegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref193 => {
    let {
      theme
    } = _ref193;
    return theme.palette.feedbackError;
  }),
  bodyXsN700RegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref194 => {
    let {
      theme
    } = _ref194;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN700RegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref195 => {
    let {
      theme
    } = _ref195;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN700RegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref196 => {
    let {
      theme
    } = _ref196;
    return theme.palette.baseNeutral700;
  }),
  bodyXsN500RegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref197 => {
    let {
      theme
    } = _ref197;
    return theme.palette.baseNeutral500;
  }),
  bodyXsN500RegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref198 => {
    let {
      theme
    } = _ref198;
    return theme.palette.baseNeutral500;
  }),
  bodyXsN500RegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref199 => {
    let {
      theme
    } = _ref199;
    return theme.palette.baseNeutral500;
  }),
  bodyXsG600RegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref200 => {
    let {
      theme
    } = _ref200;
    return theme.palette.primaryGreen600;
  }),
  bodyXsG600RegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref201 => {
    let {
      theme
    } = _ref201;
    return theme.palette.primaryGreen600;
  }),
  bodyXsG600RegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref202 => {
    let {
      theme
    } = _ref202;
    return theme.palette.primaryGreen600;
  }),
  bodyXsDarkRegularSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:inherit;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref203 => {
    let {
      theme
    } = _ref203;
    return theme.palette.baseDark;
  }),
  bodyXsDarkRegularDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:right;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref204 => {
    let {
      theme
    } = _ref204;
    return theme.palette.baseDark;
  }),
  bodyXsDarkRegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;text-align:center;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref205 => {
    let {
      theme
    } = _ref205;
    return theme.palette.baseDark;
  }),
  interactiveButtonsXxsN400SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:inherit;letter-spacing:0.23px;color:", ";font-family:Montserrat,sans-serif;"], _ref206 => {
    let {
      theme
    } = _ref206;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsXxsN400SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:right;letter-spacing:0.23px;color:", ";font-family:Montserrat,sans-serif;"], _ref207 => {
    let {
      theme
    } = _ref207;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsXxsN400SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:center;letter-spacing:0.23px;color:", ";font-family:Montserrat,sans-serif;"], _ref208 => {
    let {
      theme
    } = _ref208;
    return theme.palette.baseNeutral400;
  }),
  interactiveButtonsXxsG900SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:inherit;letter-spacing:0.23px;color:", ";font-family:Montserrat,sans-serif;"], _ref209 => {
    let {
      theme
    } = _ref209;
    return theme.palette.primaryGreen900;
  }),
  interactiveButtonsXxsG900SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:right;letter-spacing:0.23px;color:", ";font-family:Montserrat,sans-serif;"], _ref210 => {
    let {
      theme
    } = _ref210;
    return theme.palette.primaryGreen900;
  }),
  interactiveButtonsXxsG900SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:center;letter-spacing:0.23px;color:", ";font-family:Montserrat,sans-serif;"], _ref211 => {
    let {
      theme
    } = _ref211;
    return theme.palette.primaryGreen900;
  }),
  infoXsWhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref212 => {
    let {
      theme
    } = _ref212;
    return theme.palette.baseWhite;
  }),
  infoXsWhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref213 => {
    let {
      theme
    } = _ref213;
    return theme.palette.baseWhite;
  }),
  infoXsWhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref214 => {
    let {
      theme
    } = _ref214;
    return theme.palette.baseWhite;
  }),
  infoXsN700SemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref215 => {
    let {
      theme
    } = _ref215;
    return theme.palette.baseNeutral700;
  }),
  infoXsN700SemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref216 => {
    let {
      theme
    } = _ref216;
    return theme.palette.baseNeutral700;
  }),
  infoXsN700SemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref217 => {
    let {
      theme
    } = _ref217;
    return theme.palette.baseNeutral700;
  }),
  infoXsDarkSemiboldSx2: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref218 => {
    let {
      theme
    } = _ref218;
    return theme.palette.baseDark;
  }),
  infoXsDarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref219 => {
    let {
      theme
    } = _ref219;
    return theme.palette.baseDark;
  }),
  infoXsDarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref220 => {
    let {
      theme
    } = _ref220;
    return theme.palette.baseDark;
  }),
  infoXsDarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref221 => {
    let {
      theme
    } = _ref221;
    return theme.palette.baseDark;
  }),
  bodyXxsWhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.5;text-align:inherit;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref222 => {
    let {
      theme
    } = _ref222;
    return theme.palette.baseWhite;
  }),
  bodyXxsWhiteSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.5;text-align:right;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref223 => {
    let {
      theme
    } = _ref223;
    return theme.palette.baseWhite;
  }),
  bodyXxsWhiteSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.5;text-align:center;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref224 => {
    let {
      theme
    } = _ref224;
    return theme.palette.baseWhite;
  }),
  bodyXxsDarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref225 => {
    let {
      theme
    } = _ref225;
    return theme.palette.baseDark;
  }),
  bodyXxsDarkSemiboldDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref226 => {
    let {
      theme
    } = _ref226;
    return theme.palette.baseDark;
  }),
  bodyXxsDarkSemiboldC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref227 => {
    let {
      theme
    } = _ref227;
    return theme.palette.baseDark;
  }),
  infoXsWhite500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.25;text-align:inherit;letter-spacing:0.34px;color:", ";font-family:Montserrat,sans-serif;"], _ref228 => {
    let {
      theme
    } = _ref228;
    return theme.palette.baseWhite;
  }),
  infoXsWhite500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.25;text-align:right;letter-spacing:0.34px;color:", ";font-family:Montserrat,sans-serif;"], _ref229 => {
    let {
      theme
    } = _ref229;
    return theme.palette.baseWhite;
  }),
  infoXsWhite500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.25;text-align:center;letter-spacing:0.34px;color:", ";font-family:Montserrat,sans-serif;"], _ref230 => {
    let {
      theme
    } = _ref230;
    return theme.palette.baseWhite;
  }),
  infoXsN700500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref231 => {
    let {
      theme
    } = _ref231;
    return theme.palette.baseNeutral700;
  }),
  infoXsN700500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref232 => {
    let {
      theme
    } = _ref232;
    return theme.palette.baseNeutral700;
  }),
  infoXsN700500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref233 => {
    let {
      theme
    } = _ref233;
    return theme.palette.baseNeutral700;
  }),
  infoXsDark500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref234 => {
    let {
      theme
    } = _ref234;
    return theme.palette.baseDark;
  }),
  infoXsDark500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref235 => {
    let {
      theme
    } = _ref235;
    return theme.palette.baseDark;
  }),
  infoXsDark500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:normal;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref236 => {
    let {
      theme
    } = _ref236;
    return theme.palette.baseDark;
  }),
  bodyXxsWhite500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.5;text-align:inherit;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref237 => {
    let {
      theme
    } = _ref237;
    return theme.palette.baseWhite;
  }),
  bodyXxsWhite500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.5;text-align:right;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref238 => {
    let {
      theme
    } = _ref238;
    return theme.palette.baseWhite;
  }),
  bodyXxsWhite500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.5;text-align:center;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref239 => {
    let {
      theme
    } = _ref239;
    return theme.palette.baseWhite;
  }),
  bodyXxsG900500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:inherit;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref240 => {
    let {
      theme
    } = _ref240;
    return theme.palette.primaryGreen900;
  }),
  bodyXxsG900500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:right;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref241 => {
    let {
      theme
    } = _ref241;
    return theme.palette.primaryGreen900;
  }),
  bodyXxsG900500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:center;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref242 => {
    let {
      theme
    } = _ref242;
    return theme.palette.primaryGreen900;
  }),
  bodyXxsDark500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:inherit;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref243 => {
    let {
      theme
    } = _ref243;
    return theme.palette.baseDark;
  }),
  bodyXxsDark500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:right;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref244 => {
    let {
      theme
    } = _ref244;
    return theme.palette.baseDark;
  }),
  bodyXxsDark500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.3;text-align:center;letter-spacing:0.4px;color:", ";font-family:Montserrat,sans-serif;"], _ref245 => {
    let {
      theme
    } = _ref245;
    return theme.palette.baseDark;
  }),
  feedbackXsErrorRegularC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:12px;line-height:1.5;text-align:center;letter-spacing:0.17px;color:", ";font-family:Montserrat,sans-serif;"], _ref246 => {
    let {
      theme
    } = _ref246;
    return theme.palette.feedbackError;
  }),
  bodyXxxsWhiteSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;line-height:1.56;text-align:inherit;letter-spacing:0.33px;color:", ";font-family:Montserrat,sans-serif;"], _ref247 => {
    let {
      theme
    } = _ref247;
    return theme.palette.baseWhite;
  }),
  bodyXxxsDarkSemiboldSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;line-height:1.56;text-align:inherit;letter-spacing:0.33px;color:", ";font-family:Montserrat,sans-serif;"], _ref248 => {
    let {
      theme
    } = _ref248;
    return theme.palette.baseDark;
  }),
  infoXxsN700500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;line-height:normal;text-align:inherit;letter-spacing:0.33px;color:", ";font-family:Montserrat,sans-serif;"], _ref249 => {
    let {
      theme
    } = _ref249;
    return theme.palette.baseNeutral700;
  }),
  infoXxsN700500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;line-height:normal;text-align:right;letter-spacing:0.33px;color:", ";font-family:Montserrat,sans-serif;"], _ref250 => {
    let {
      theme
    } = _ref250;
    return theme.palette.baseNeutral700;
  }),
  infoXxsN700500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;line-height:normal;text-align:center;letter-spacing:0.33px;color:", ";font-family:Montserrat,sans-serif;"], _ref251 => {
    let {
      theme
    } = _ref251;
    return theme.palette.baseNeutral700;
  }),
  infoXxsDark500Sx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;line-height:normal;text-align:inherit;letter-spacing:0.33px;color:", ";font-family:Montserrat,sans-serif;"], _ref252 => {
    let {
      theme
    } = _ref252;
    return theme.palette.baseDark;
  }),
  infoXxsDark500Dx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;line-height:normal;text-align:right;letter-spacing:0.33px;color:#2b2b2b;font-family:Montserrat,sans-serif;"]),
  infoXxsDark500C: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;line-height:normal;text-align:center;letter-spacing:0.33px;color:#2b2b2b;font-family:Montserrat,sans-serif;"]),
  bodyXsDarkMediumSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:14px;line-height:1.29;letter-spacing:0.2px;color:", ";font-family:Montserrat,sans-serif;"], _ref253 => {
    let {
      theme
    } = _ref253;
    return theme.palette.baseDark;
  }),
  infoXxsN700MediumC: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:10px;text-align:center;letter-spacing:0.33px;color:", ";font-family:Montserrat,sans-serif;"], _ref254 => {
    let {
      theme
    } = _ref254;
    return theme.palette.baseNeutral700;
  }),
  bodySDarkMediumSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1rem;line-height:20.8px;letter-spacing:0.3px;color:", ";font-family:Montserrat-Medium,sans-serif;"], _ref255 => {
    let {
      theme
    } = _ref255;
    return theme.palette.baseDark;
  }),
  interactiveButtonsSG800MediumSx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:1rem;line-height:22.8px;letter-spacing:0.3px;color:", ";font-family:Montserrat-Medium,sans-serif;"], _ref256 => {
    let {
      theme
    } = _ref256;
    return theme.palette.primaryGreen800;
  }),
  infoXxsN700MediumDx: (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(["font-size:0.75rem;line-height:10px;letter-spacing:0.4px;color:", ";font-family:Montserrat-Medium,sans-serif;"], _ref257 => {
    let {
      theme
    } = _ref257;
    return theme.palette.baseNeutral700;
  })
};

/***/ })

}]);